import { DeleteOrgLogoRequestSchema, DeleteOrgLogoResponseSchema } from './delete-org-logo.schema';
/**
 * Delete Org Logo Endpoint Contract
 * Removes organization's logo
 */ export const deleteOrgLogoContract = {
    method: 'DELETE',
    path: '/api/v2/org-logo',
    description: 'Delete organization logo',
    requestSchema: DeleteOrgLogoRequestSchema,
    responseSchema: DeleteOrgLogoResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            404: 'Organization not found',
            500: 'Internal server error'
        }
    }
};

//# sourceMappingURL=delete-org-logo.contract.js.map